import { FileType } from '@lmt/shared-types';
import DocIcon from '@lmt/unicorn-shared/app/icons/document-icons/doc.svg?react';
import ExcelIcon from '@lmt/unicorn-shared/app/icons/document-icons/excel.svg?react';
import ImageIcon from '@lmt/unicorn-shared/app/icons/document-icons/img.svg?react';
import DefaultIcon from '@lmt/unicorn-shared/app/icons/document-icons/no-type.svg?react';
import PdfIcon from '@lmt/unicorn-shared/app/icons/document-icons/pdf.svg?react';
import PptIcon from '@lmt/unicorn-shared/app/icons/document-icons/ppt.svg?react';
import TxtIcon from '@lmt/unicorn-shared/app/icons/document-icons/txt.svg?react';
import InternalDocumentIcon from '@lmt/unicorn-shared/app/icons/document-icons/uni-doc.svg?react';
import ZipIcon from '@lmt/unicorn-shared/app/icons/document-icons/zip.svg?react';
import React from 'react';
import styles from './DocumentIcon.module.scss';
import clsx from 'clsx';

interface Props {
  filename: string;
  fileType: FileType;
  className?: string;
}

export const DocumentIcon: React.FC<Props> = (props) => {
  const { filename, fileType, className } = props;
  if (fileType === FileType.DocumentDraft) {
    return <InternalDocumentIcon className={clsx(styles.icon, className)} />;
  }
  const extension = filename.split('.').pop()?.toLowerCase();
  switch (extension) {
    case 'doc':
    case 'docx':
    case 'rtf':
      return <DocIcon className={clsx(styles.icon, className)} />;
    case 'xls':
    case 'xlsx':
      return <ExcelIcon className={clsx(styles.icon, className)} />;
    case 'pdf':
      return <PdfIcon className={clsx(styles.icon, className)} />;
    case 'ppt':
    case 'pptx':
      return <PptIcon className={clsx(styles.icon, className)} />;
    case 'txt':
      return <TxtIcon className={clsx(styles.icon, className)} />;
    case 'png':
    case 'jpg':
    case 'jpeg':
      return <ImageIcon className={clsx(styles.icon, className)} />;
    case 'zip':
      return <ZipIcon className={clsx(styles.icon, className)} />;
    default:
      return <DefaultIcon className={clsx(styles.icon, className)} />;
  }
};
